import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../lib/constants';
import { trackInitiateCheckout } from '../lib/pixel';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  variant?: 'gold' | 'navy';
  size?: 'md' | 'lg';
  id?: string;
  className?: string;
};
export function CtaButton({
  label = 'QUIERO EL SISTEMA MAESTRO DE TRT',
  subLabel,
  variant = 'gold',
  size = 'lg',
  id,
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full max-w-xl items-center justify-center gap-2 rounded-2xl font-extrabold uppercase tracking-wide text-center leading-tight transition-transform duration-200 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/60';
  const sizes = size === 'lg' ? 'px-5 py-4 text-[15px] sm:text-lg shadow-[0_10px_0_0_rgba(138,109,42,0.55)]' : 'px-4 py-3.5 text-[13px] sm:text-base shadow-[0_8px_0_0_rgba(138,109,42,0.5)]';
  const variants = variant === 'gold' ? 'bg-gold-500 text-navy-950 hover:bg-gold-400' : 'bg-navy-900 text-white hover:bg-navy-800 shadow-[0_10px_0_0_rgba(8,24,43,0.45)]';
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-46" data-mp="3a0u5s1zxhtpu">
      <a id={id} href={CHECKOUT_URL} onClick={trackInitiateCheckout} className={`${base} ${sizes} ${variants}`} data-id="element-47" data-mp="3ew9fchqwl3gg">
        <span className="break-words" data-id="element-48" data-mp="3owa10ac8vvnt">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-49" data-mp="3ovigbuk6ricb" />
      </a>
      {subLabel ? <p className="mt-3 px-2 text-center text-[12px] font-medium text-navy-800/70 sm:text-sm" data-id="element-50" data-mp="1jhiqo9qtlk7">
          {subLabel}
        </p> : null}
    </div>;
}